import { useToast } from '@/components/ui/use-toast'
import { ApolloError } from '@apollo/client'
import { useUpdateEstateMediaMutation } from '@gql'
import { useTranslation } from 'react-i18next'

export const useUpdateEstateMedia = () => {
  const { t } = useTranslation()
  const { toast } = useToast()

  const onError = (error: ApolloError) => {
    console.error(error)
    toast({
      title: t('useUpdateEstateMedia.error.title'),
      description: t('useUpdateEstateMedia.error.description'),
      variant: 'destructive',
    })
  }
  const refetchQueries = ['getEstateMedia']

  const [updateEstateMedia, { data, loading, error }] =
    useUpdateEstateMediaMutation({
      onError,
      refetchQueries,
    })

  return { updateEstateMedia, data, loading, error }
}
